'use strict';

const _config = {
    sideBar: document.getElementById('sideBarPrimaryNav'),
    toggleButton: document.getElementById('toggleSideNavigation'),
    mainSection: document.querySelector('main'),
};

function updateSidebarVisibility() {
    if (window.innerWidth < 800) {
        _config.sideBar?.classList.add('hidden');
        _config.mainSection?.classList.remove('shifted');
    } else {
        _config.sideBar?.classList.remove('hidden');
        _config.mainSection?.classList.add('shifted');
    }
}

export function init(){

    _config.sideBar = document.getElementById('sideBarPrimaryNav');
    _config.toggleButton = document.getElementById('toggleSideNavigation');
    _config.mainSection = document.querySelector('main');

    if (_config.toggleButton) {
        _config.toggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            _config.sideBar.classList.toggle('hidden');
            _config.mainSection.classList.toggle('shifted');
            EQLAPP.COMMON.forceResize();
        });
    }

    window.addEventListener('resize', updateSidebarVisibility);
    window.addEventListener('load', updateSidebarVisibility);

};